import React, { AnchorHTMLAttributes } from "react";
import cx from "clsx";
import Link, { type LinkProps } from "next/link";
import { cleanHtmlRestProps } from "@/lib/utils";

type AnchorProps = Omit<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  keyof LinkProps
> &
  LinkProps;

export function Anchor({ className, ...restProps }: AnchorProps) {
  return (
    <Link
      className={cx(
        "font-sans text-link normal-case text-foreground underline decoration-solid underline-offset-4 transition-colors duration-200 hover:text-primary disabled:text-disabled",
        className
      )}
      {...cleanHtmlRestProps(restProps)}
    />
  );
}
